export default __webpack_public_path__ + "static/media/pragmatic-mono.9b118196.svg";